<div class="recorridos-container">
  <app-info-banner
    [title]="'Viajes del vehículo'"
    [message]="
      'Muestra los viajes del vehículo seleccionado: sus últimos 10, los de un día o los de un rango libre de fechas. Sobre esos viajes se pueden superponer las paradas (filtrables por tiempo detenido y estado del motor), los excesos de velocidad a partir de una velocidad dada, los eventos y las zonas por las que pasó.'
    "
    [icon]="'fork_right'"
    [collapsible]="true"
  ></app-info-banner>

  <!-- Capas adicionales globales -->
  <div class="overlays-global-section">
    <app-section-title
      icon="layers"
      title="Capas adicionales"
      margin="0"
      [divisor]="false"
    ></app-section-title>

    <div class="overlays-compact">
      <div class="overlays-inputs-row">
        <mat-form-field appearance="outline" class="overlay-input-compact">
          <!-- Referencia de cómo se ve el marker de paradas en el mapa -->
          <span
            matPrefix
            class="marker-ref marker-ref-parada"
            tooltip="Así se ven las paradas en el mapa"
          ></span>
          <input
            matInput
            type="number"
            placeholder="Tiempo detenido"
            [(ngModel)]="tiempoDetenidoMinutos"
            (ngModelChange)="onParadasInputChange()"
            (wheel)="$any($event.target).blur()"
            min="0"
            max="999"
          />
          <span matSuffix>min</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="overlay-input-compact">
          <!-- Referencia de cómo se ve el marker de exceso de velocidad -->
          <span
            matPrefix
            class="marker-ref marker-ref-exceso"
            tooltip="Así se ven los excesos de velocidad en el mapa"
          ></span>
          <input
            matInput
            type="number"
            placeholder="Exc. velocidad"
            [(ngModel)]="velocidadExceso"
            (ngModelChange)="onExcesoInputChange()"
            (wheel)="$any($event.target).blur()"
            min="0"
            max="300"
          />
          <span matSuffix>km/h</span>
        </mat-form-field>
      </div>

      <!-- Estado del motor: sólo tiene sentido con un tiempo detenido cargado -->
      @if (mostrarParadasOverlay) {
        <div class="overlays-inputs-row">
          <mat-form-field appearance="outline" class="overlay-input-motor">
            <mat-icon matPrefix>power_settings_new</mat-icon>
            <mat-label>Motor en la parada</mat-label>
            <mat-select
              [(ngModel)]="estadoMotorParadas"
              (ngModelChange)="onParadasInputChange()"
            >
              <mat-option value="">Todos los estados</mat-option>
              <mat-option value="apagado">Detenido y apagado</mat-option>
              <mat-option value="encendido">Detenido y encendido</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div class="overlays-toggles-section">
        <div class="overlay-toggle-row">
          <!-- Referencia de cómo se ven los eventos en el mapa -->
          <span
            class="marker-ref marker-ref-evento"
            tooltip="Así se ven los eventos en el mapa"
          ></span>
          <span class="overlay-label-text">Eventos</span>
          <mat-slide-toggle
            [(ngModel)]="mostrarEventosOverlay"
            (change)="onEventosToggleChange()"
            color="primary"
          ></mat-slide-toggle>
        </div>

        <div class="overlay-toggle-row">
          <mat-icon class="overlay-icon zona-icon">location_on</mat-icon>
          <span class="overlay-label-text">Zonas</span>
          @if (mostrarZonasOverlay) {
            <mat-form-field
              appearance="outline"
              class="overlay-input-compact overlay-input-zona"
              tooltip="Minutos mínimos dentro de la zona"
            >
              <input
                matInput
                type="number"
                placeholder="Min."
                [(ngModel)]="minutosEnZona"
                (ngModelChange)="onZonasInputChange()"
                (wheel)="$any($event.target).blur()"
                min="0"
                max="999"
              />
              <span matSuffix>min</span>
            </mat-form-field>
          }
          <mat-slide-toggle
            [(ngModel)]="mostrarZonasOverlay"
            (change)="onZonasToggleChange()"
            color="primary"
          ></mat-slide-toggle>
        </div>
      </div>

      <!-- Estilo del recorrido: todo junto y plegable, sólo íconos con
           tooltip. Con etiquetas no entraba ninguna en el ancho del panel. -->
      <div class="estilo-capsula">
        <button
          type="button"
          class="irx-sin-estilo estilo-cabecera"
          (click)="estiloAbierto = !estiloAbierto"
          [attr.aria-expanded]="estiloAbierto"
        >
          <mat-icon class="overlay-icon traza-icon">brush</mat-icon>
          <span class="estilo-titulo">Estilo del recorrido</span>
          <mat-icon class="estilo-flecha">
            {{ estiloAbierto ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>

        @if (estiloAbierto) {
          <div class="estilo-controles">
            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="verTraza"
              (click)="verTraza = !verTraza; onEstiloTrazaChange()"
              [tooltip]="verTraza ? 'Traza visible' : 'Traza oculta'"
            >
              <mat-icon>{{ verTraza ? 'show_chart' : 'hide_source' }}</mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="estiloLinea === 'punteada'"
              (click)="ciclarEstiloLinea()"
              [tooltip]="tooltipEstiloLinea"
            >
              <mat-icon>
                {{ estiloLinea === 'punteada' ? 'more_horiz' : 'remove' }}
              </mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="modoColorTraza !== 'plano'"
              (click)="ciclarModoColor()"
              [tooltip]="tooltipModoColor"
            >
              <mat-icon>{{ iconoModoColor }}</mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="separarIdaYVuelta"
              (click)="
                separarIdaYVuelta = !separarIdaYVuelta; onEstiloTrazaChange()
              "
              [tooltip]="
                separarIdaYVuelta
                  ? 'Ida y vuelta separadas a cada lado de la calle'
                  : 'Ida y vuelta superpuestas sobre el mismo camino'
              "
            >
              <mat-icon>merge_type</mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="trazaAnimada && puedeAnimar"
              [disabled]="!puedeAnimar"
              (click)="trazaAnimada = !trazaAnimada; onEstiloTrazaChange()"
              [tooltip]="
                !puedeAnimar
                  ? 'El movimiento necesita un solo mapa en la vista'
                  : trazaAnimada
                    ? 'Movimiento corriendo sobre la traza'
                    : 'Traza quieta, sin movimiento'
              "
            >
              <mat-icon>animation</mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="trazaPegadaACalle"
              (click)="
                trazaPegadaACalle = !trazaPegadaACalle; onTrazaToggleChange()
              "
              [tooltip]="
                trazaPegadaACalle
                  ? 'Traza pegada a la calle'
                  : 'Traza uniendo los reportes con rectas'
              "
            >
              <mat-icon>route</mat-icon>
            </button>

            <!-- Por velocidad el color lo pone la escala, no la línea. -->
            @if (modoColorTraza !== 'velocidad') {
              <input
                type="color"
                class="color-traza"
                [(ngModel)]="colorLinea"
                (change)="onColorLineaChange()"
                tooltip="Color de la línea"
                aria-label="Color de la línea"
              />
            }
            @if (modoColorTraza === 'degradado') {
              <input
                type="color"
                class="color-traza"
                [(ngModel)]="colorDegradadoInicio"
                (change)="onColorDegradadoInicioChange()"
                tooltip="Color con el que arranca el degradado"
                aria-label="Color de arranque del degradado"
              />
            }
            @if (trazaAnimada) {
              <input
                type="color"
                class="color-traza"
                [(ngModel)]="colorMovimiento"
                (change)="onColorMovimientoChange()"
                tooltip="Color del movimiento"
                aria-label="Color del movimiento"
              />
            }
          </div>

          @if (modoColorTraza === 'velocidad') {
            <div class="leyenda-velocidad">
              <button
                irxBotonIcono="borde"
                tamano="compacto"
                class="control-icono"
                [activo]="escalaVelocidadRelativa"
                (click)="alternarEscalaVelocidad()"
                [tooltip]="
                  escalaVelocidadRelativa
                    ? 'Escala relativa: de la mínima a la máxima del viaje'
                    : 'Escala fija en km/h'
                "
              >
                <mat-icon>
                  {{ escalaVelocidadRelativa ? 'unfold_more' : 'straighten' }}
                </mat-icon>
              </button>
              <div class="escala-velocidad" aria-label="Escala de velocidad">
                <span
                  class="barra-velocidad"
                  [style.background]="fondoEscalaVelocidad"
                ></span>
                <span class="etiquetas-velocidad">
                  @for (etiqueta of etiquetasEscalaVelocidad; track $index) {
                    <span>{{ etiqueta }}</span>
                  }
                </span>
              </div>
              <span class="unidad-velocidad">km/h</span>
            </div>
          }

          <!-- Segundo nivel: de dónde salen los puntos y qué más se ve -->
          <div class="estilo-controles">
            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="verReportes"
              (click)="verReportes = !verReportes; onEstiloTrazaChange()"
              [tooltip]="verReportes ? 'Reportes visibles' : 'Reportes ocultos'"
            >
              <mat-icon>
                {{ verReportes ? 'scatter_plot' : 'blur_off' }}
              </mat-icon>
            </button>

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="reportesSnapeados"
              [disabled]="loadingReportes"
              (click)="
                reportesSnapeados = !reportesSnapeados;
                onReportesSnapeadosToggleChange()
              "
              [tooltip]="
                reportesSnapeados
                  ? 'Reportes ajustados a la calle'
                  : 'Reportes donde los reportó el tracker'
              "
            >
              <mat-icon>adjust</mat-icon>
            </button>

            <input
              type="color"
              class="color-traza"
              [(ngModel)]="colorReportes"
              (change)="onEstiloTrazaChange()"
              tooltip="Color de los reportes"
              aria-label="Color de los reportes"
            />

            <button
              irxBotonIcono="borde"
              tamano="compacto"
              class="control-icono"
              [activo]="tamanoReportesAbierto"
              (click)="tamanoReportesAbierto = !tamanoReportesAbierto"
              [tooltip]="'Tamaño de los reportes: ' + tamanoReportes + ' px'"
            >
              <mat-icon>photo_size_select_small</mat-icon>
            </button>

            @if (tamanoReportesAbierto) {
              <input
                type="range"
                class="barra-tamano"
                min="2"
                max="7"
                step="1"
                [(ngModel)]="tamanoReportes"
                (ngModelChange)="onTamanoReportesChange()"
                [tooltip]="tamanoReportes + ' px'"
                aria-label="Tamaño de los reportes"
              />
            }

            <button
              irxBotonIcono
              tamano="compacto"
              class="control-icono restaurar"
              (click)="restaurarColores()"
              tooltip="Volver a los colores por defecto"
            >
              <mat-icon>format_color_reset</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="form-section" style="padding-bottom: 10px">
    <!-- Selector de tipo de búsqueda con toggle buttons -->
    <div class="campo-grupo">
      <app-section-title
        title="Tipo de búsqueda"
        margin="0"
        [divisor]="false"
      ></app-section-title>

      <app-horizontal-scroller>
        <irx-segmentado
          class="tipo-busqueda-toggle"
          [(ngModel)]="tipoBusqueda"
          (ngModelChange)="onTipoBusquedaChange()"
        >
          <irx-segmento value="ultimos10" class="toggle-option">
            <mat-icon>update</mat-icon>
            Últimos 10
          </irx-segmento>
          <irx-segmento value="fecha" class="toggle-option">
            <mat-icon>event</mat-icon>
            Fecha
          </irx-segmento>
          <irx-segmento value="viaje" class="toggle-option">
            <mat-icon>fork_right</mat-icon>
            Viaje
          </irx-segmento>
        </irx-segmentado>
      </app-horizontal-scroller>
    </div>

    <!-- Selector de fecha (no visible en 'Últimos 10') -->
    @if (tipoBusqueda !== 'ultimos10') {
      <div class="campo-grupo">
        <app-section-title
          icon="event"
          title="Fecha"
          margin="0"
          [divisor]="false"
        ></app-section-title>

        <app-date-range-picker
          [(ngModel)]="range"
          [maxHoras]="24"
          [(modoAvanzado)]="modoAvanzadoFecha"
        />
      </div>
    }
  </div>

  @if (mostrarMensajeVehiculoRequerido) {
    <app-hint
      [color]="'red'"
      [icon]="'warning'"
      [message]="
        'Seleccioná un vehículo en el mapa antes de realizar la búsqueda.'
      "
    ></app-hint>
  }

  @if (mostrarMensajeSinResultados) {
    <app-hint
      [color]="'red'"
      [icon]="'error'"
      [message]="
        'No se encontraron viajes para los criterios de búsqueda especificados.'
      "
    ></app-hint>
  }

  <!-- Lista de viajes - visible en búsqueda por viaje y últimos 10 -->
  @if (tipoBusqueda === 'viaje' || tipoBusqueda === 'ultimos10') {
    <div class="viajes-section">
      <app-section-title
        icon="list"
        title="Viajes disponibles"
        margin="0"
        [divisor]="false"
      ></app-section-title>

      <mat-accordion class="viajes-container">
        @for (inter of interaccionesBusqueda; track inter) {
          <mat-expansion-panel
            class="viaje-panel"
            [ngClass]="
              interaccionesBusquedaSelected === inter
                ? 'viaje-selected'
                : 'viaje-unselected'
            "
            [disabled]="
              loadingReportes && interaccionesBusquedaSelected !== inter
            "
            (opened)="onRecorridoOpened(inter)"
            (closed)="onRecorridoClosed(inter)"
          >
            <mat-expansion-panel-header class="viaje-header">
              <mat-panel-title class="viaje-title">
                <div class="viaje-info">
                  <mat-icon class="viaje-icon">directions</mat-icon>
                  <div class="viaje-tiempo">
                    @if (inter.enCurso) {
                      <span class="tiempo-inicio">
                        {{ inter.startTime | date: 'dd/MM/yyyy HH:mm' }}
                      </span>
                      <span class="badge-en-curso">En curso</span>
                    } @else if (inter.startTime !== inter.endTime) {
                      <span class="tiempo-inicio">
                        {{ inter.startTime | date: 'dd/MM/yyyy HH:mm' }}
                      </span>
                      <mat-icon class="flecha-tiempo">arrow_forward</mat-icon>
                      <span class="tiempo-fin">
                        {{ inter.endTime | date: 'HH:mm' }}
                      </span>
                    } @else {
                      <span class="tiempo-unico">
                        {{ inter.startTime | date: 'dd/MM/yyyy HH:mm' }}
                      </span>
                    }
                  </div>
                </div>
              </mat-panel-title>
              <mat-panel-description class="viaje-description">
                @if (
                  loadingReportes && interaccionesBusquedaSelected === inter
                ) {
                  <mat-spinner diameter="20" color="primary"></mat-spinner>
                }
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Contenido del panel expandido -->
            <div class="viaje-content">
              <div class="viaje-detalles">
                <!-- Mismos números que el Excel (RecorridosService.metricasDeViaje) -->
                @let metricas = metricasViaje(inter);
                <!-- Primera fila: Duración y Distancia -->
                <div class="detalle-fila">
                  <div class="detalle-item">
                    <mat-icon class="detalle-icon">schedule</mat-icon>
                    <div class="detalle-info">
                      <span class="detalle-label">Duración:</span>
                      <span class="detalle-valor">
                        @if (inter.duration) {
                          {{ formatearDuracion(inter.duration) }}
                        } @else if (inter.startTime !== inter.endTime) {
                          {{ getDuracionViaje(inter.startTime, inter.endTime) }}
                        } @else {
                          Instantáneo
                        }
                      </span>
                    </div>
                  </div>

                  <!-- Siempre visible: un 0 de tripero es falta de dato y se
                       dice, en vez de esconder la fila. -->
                  <div class="detalle-item">
                    <mat-icon class="detalle-icon">straighten</mat-icon>
                    <div class="detalle-info">
                      <span class="detalle-label">Distancia:</span>
                      <span class="detalle-valor">
                        @if (metricas.distanciaM != null) {
                          {{ metricas.distanciaM / 1000 | number: '1.2-2' }} km
                        } @else {
                          Sin dato
                        }
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Segunda fila: Velocidades -->
                <div class="detalle-fila">
                  <div
                    class="detalle-item"
                    [tooltip]="ayudaVelocidadPromedioViaje"
                  >
                    <mat-icon class="detalle-icon">speed</mat-icon>
                    <div class="detalle-info">
                      <span class="detalle-label">Vel. Promedio:</span>
                      <span class="detalle-valor">
                        @if (metricas.velocidadPromedio != null) {
                          {{ metricas.velocidadPromedio | number: '1.0-0' }}
                          km/h
                        } @else {
                          Sin dato
                        }
                      </span>
                    </div>
                  </div>

                  <div class="detalle-item">
                    <mat-icon class="detalle-icon">speed</mat-icon>
                    <div class="detalle-info">
                      <span class="detalle-label">Vel. Máxima:</span>
                      <span class="detalle-valor">
                        @if (metricas.velocidadMaxima != null) {
                          {{ metricas.velocidadMaxima | number: '1.0-0' }} km/h
                        } @else {
                          Sin dato
                        }
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Consumo de combustible (sensor de nivel) -->
                @let consumo = consumosViaje.get(claveConsumoViaje(inter));
                @if (
                  consumosViaje.has(claveConsumoViaje(inter)) &&
                  consumo !== null
                ) {
                  <div class="detalle-fila" [tooltip]="consumo?.detalle ?? ''">
                    <div class="detalle-item">
                      <mat-icon class="detalle-icon">
                        local_gas_station
                      </mat-icon>
                      <div class="detalle-info">
                        <span class="detalle-label">Consumo total:</span>
                        <span class="detalle-valor">
                          @if (consumo === undefined) {
                            <mat-spinner diameter="14"></mat-spinner>
                          } @else {
                            @if (consumo.total != null) {
                              {{ consumo.total }}
                            } @else {
                              <span class="no-info">Sin datos</span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                    @if (consumo) {
                      <div class="detalle-item">
                        <mat-icon class="detalle-icon">eco</mat-icon>
                        <div class="detalle-info">
                          <span class="detalle-label">Consumo prom.:</span>
                          <span class="detalle-valor">
                            @if (consumo.principal) {
                              {{ consumo.principal }}
                              @if (consumo.secundario) {
                                <span class="consumo-secundario">
                                  · {{ consumo.secundario }}
                                </span>
                              }
                            } @else {
                              <span class="consumo-sin-datos no-info">
                                Sin datos
                              </span>
                            }
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Listas de paradas y eventos del viaje -->
              @if (
                mostrarParadasOverlay && interaccionesBusquedaSelected === inter
              ) {
                <app-lista-paradas
                  [paradas]="paradasEnViaje"
                  [seleccionada]="paradaSeleccionada"
                  [estadoMotor]="estadoMotorParadas"
                  [mostrarFiltroMotor]="false"
                  [umbralMinutos]="tiempoDetenidoMinutos"
                  [cargando]="cargandoOverlay('paradas', inter)"
                  (seleccionar)="onParadaSeleccionada($event)"
                ></app-lista-paradas>
              }

              @if (
                mostrarExcesoVelocidadOverlay &&
                interaccionesBusquedaSelected === inter
              ) {
                <app-lista-excesos
                  [excesos]="puntosExcesoVelocidad"
                  [velocidadMinima]="velocidadExceso"
                  [cargando]="cargandoOverlay('exceso', inter)"
                  (seleccionar)="onExcesoSeleccionado($event)"
                ></app-lista-excesos>
              }

              @if (
                mostrarEventosOverlay && interaccionesBusquedaSelected === inter
              ) {
                <app-lista-eventos
                  [eventos]="eventosEnViaje"
                  [seleccionado]="eventoSeleccionado"
                  [cargando]="cargandoOverlay('eventos', inter)"
                  (seleccionar)="onEventoSeleccionado($event)"
                ></app-lista-eventos>
              }

              <!-- Lista de zonas visitadas en el viaje -->
              @if (
                mostrarZonasOverlay && interaccionesBusquedaSelected === inter
              ) {
                <app-lista-categoria
                  titulo="Zonas visitadas"
                  icono="location_on"
                  color="#ff9800"
                  [items]="itemsZonas"
                  [cargando]="loadingOverlaysFecha || loadingZonasPanel"
                  textoVacio="Sin zonas detectadas"
                  (verEnMapa)="onZonaSeleccionada($event)"
                ></app-lista-categoria>
              }

              <!-- Botones de acción (siempre al final) -->
              <div class="viaje-acciones">
                <button
                  irxBoton="tonal"
                  (click)="verDetalleViaje(inter)"
                  class="accion-boton"
                  [disabled]="loadingReportes"
                >
                  <mat-icon>visibility</mat-icon>
                  Ver en mapa
                </button>
                <app-button
                  matType="mat-raised-button"
                  color="accent"
                  (click)="exportarReportes(inter)"
                  icon="file_download"
                  text="Exportar"
                  class="accion-boton"
                  [disabled]="!vehiculo"
                  [loading]="exportando"
                  tooltip="Exportar reportes del viaje"
                ></app-button>
              </div>
            </div>
          </mat-expansion-panel>
        }
        @if (interaccionesBusqueda.length === 0) {
          <app-empty-state
            [message]="
              'No se encontraron viajes para el vehículo y fecha seleccionados'
            "
            [icon]="'search_off'"
          ></app-empty-state>
        }
      </mat-accordion>
    </div>
  }

  <!-- Resumen de búsqueda por fecha -->
  @if (tipoBusqueda === 'fecha' && lastTripStartTime) {
    <div class="fecha-resumen-section">
      <div class="viaje-detalles">
        <!-- Inicio y Fin -->
        <div class="detalle-fila">
          <div class="detalle-item">
            <mat-icon class="detalle-icon">play_circle</mat-icon>
            <div class="detalle-info">
              <span class="detalle-label">Inicio:</span>
              <span class="detalle-valor">
                {{ lastTripStartTime | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          </div>
          <div class="detalle-item">
            <mat-icon class="detalle-icon">stop_circle</mat-icon>
            <div class="detalle-info">
              <span class="detalle-label">Fin:</span>
              <span class="detalle-valor">
                {{ lastTripEndTime | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Duración y Distancia -->
        <div class="detalle-fila">
          <div class="detalle-item">
            <mat-icon class="detalle-icon">schedule</mat-icon>
            <div class="detalle-info">
              <span class="detalle-label">Duración:</span>
              <span class="detalle-valor">
                {{ getDuracionViaje(lastTripStartTime, lastTripEndTime!) }}
              </span>
            </div>
          </div>
          @if (fechaResumenDistanciaKm != null) {
            <div class="detalle-item">
              <mat-icon class="detalle-icon">straighten</mat-icon>
              <div class="detalle-info">
                <span class="detalle-label">Distancia:</span>
                <span class="detalle-valor">
                  {{ fechaResumenDistanciaKm | number: '1.2-2' }} km
                </span>
              </div>
            </div>
          }
        </div>

        <!-- Velocidades -->
        @if (fechaResumenAvgSpeed != null || fechaResumenMaxSpeed != null) {
          <div class="detalle-fila">
            @if (fechaResumenAvgSpeed != null) {
              <div class="detalle-item" [tooltip]="ayudaVelocidadPromedioFecha">
                <mat-icon class="detalle-icon">speed</mat-icon>
                <div class="detalle-info">
                  <span class="detalle-label">Vel. Promedio:</span>
                  <span class="detalle-valor">
                    {{ fechaResumenAvgSpeed | number: '1.0-0' }} km/h
                  </span>
                </div>
              </div>
            }
            @if (fechaResumenMaxSpeed != null) {
              <div class="detalle-item">
                <mat-icon class="detalle-icon">speed</mat-icon>
                <div class="detalle-info">
                  <span class="detalle-label">Vel. Máxima:</span>
                  <span class="detalle-valor">
                    {{ fechaResumenMaxSpeed | number: '1.0-0' }} km/h
                  </span>
                </div>
              </div>
            }
          </div>
        }

        <!-- Consumo de combustible (sensor de nivel) -->
        @if (consumoFecha !== null) {
          <div class="detalle-fila" [tooltip]="consumoFecha?.detalle ?? ''">
            <div class="detalle-item">
              <mat-icon class="detalle-icon">local_gas_station</mat-icon>
              <div class="detalle-info">
                <span class="detalle-label">Consumo total:</span>
                <span class="detalle-valor">
                  @if (consumoFecha === undefined) {
                    <mat-spinner diameter="14"></mat-spinner>
                  } @else {
                    @if (consumoFecha.total != null) {
                      {{ consumoFecha.total }}
                    } @else {
                      <span class="no-info">Sin datos</span>
                    }
                  }
                </span>
              </div>
            </div>
            @if (consumoFecha) {
              <div class="detalle-item">
                <mat-icon class="detalle-icon">eco</mat-icon>
                <div class="detalle-info">
                  <span class="detalle-label">Consumo prom.:</span>
                  <span class="detalle-valor">
                    @if (consumoFecha.principal) {
                      {{ consumoFecha.principal }}
                      @if (consumoFecha.secundario) {
                        <span class="consumo-secundario">
                          · {{ consumoFecha.secundario }}
                        </span>
                      }
                    } @else {
                      <span class="consumo-sin-datos no-info">Sin datos</span>
                    }
                  </span>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Listas de paradas y eventos (búsqueda por fecha) -->
      @if (mostrarParadasOverlay) {
        <app-lista-paradas
          [paradas]="paradasEnViaje"
          [seleccionada]="paradaSeleccionada"
          [estadoMotor]="estadoMotorParadas"
          [mostrarFiltroMotor]="false"
          [umbralMinutos]="tiempoDetenidoMinutos"
          [cargando]="cargandoOverlay('paradas')"
          (seleccionar)="onParadaSeleccionada($event)"
        ></app-lista-paradas>
      }

      @if (mostrarExcesoVelocidadOverlay) {
        <app-lista-excesos
          [excesos]="puntosExcesoVelocidad"
          [velocidadMinima]="velocidadExceso"
          [cargando]="cargandoOverlay('exceso')"
          (seleccionar)="onExcesoSeleccionado($event)"
        ></app-lista-excesos>
      }

      @if (mostrarEventosOverlay) {
        <app-lista-eventos
          [eventos]="eventosEnViaje"
          [seleccionado]="eventoSeleccionado"
          [cargando]="cargandoOverlay('eventos')"
          (seleccionar)="onEventoSeleccionado($event)"
        ></app-lista-eventos>
      }

      <!-- Lista de zonas visitadas (búsqueda por fecha) -->
      @if (mostrarZonasOverlay) {
        <app-lista-categoria
          titulo="Zonas visitadas"
          icono="location_on"
          color="#ff9800"
          [items]="itemsZonas"
          [cargando]="loadingOverlaysFecha || loadingZonasPanel"
          textoVacio="Sin zonas detectadas"
          (verEnMapa)="onZonaSeleccionada($event)"
        ></app-lista-categoria>
      }

      <!-- Botón Exportar (debajo de zonas) -->
      <div class="viaje-acciones">
        <app-button
          matType="mat-raised-button"
          color="accent"
          (click)="exportarReportesFecha()"
          icon="file_download"
          text="Exportar"
          class="accion-boton"
          [disabled]="!vehiculo"
          [loading]="exportando"
          tooltip="Exportar reportes del recorrido"
        ></app-button>
      </div>
    </div>
  }

  <!-- Sección de acciones -->
  <div class="acciones-section">
    <div class="botones-container">
      <app-button
        matType="mat-fab"
        color="primary"
        (click)="buscar()"
        [icon]="'search'"
        [disabled]="!canBuscar"
        tooltip="Buscar viajes"
        class="boton-buscar"
      ></app-button>

      <button
        irxBotonIcono="borde"
        tono="primario"
        tamano="campo"
        (click)="resetear()"
        tooltip="Limpiar búsqueda"
        type="button"
        class="boton-resetear"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</div>
